// extracted by mini-css-extract-plugin
export default {"root":"style_root__5JQTc","buttonContainer":"style_buttonContainer__mc7O4"};